export default __webpack_public_path__ + "static/media/credit-card-change.f2a07af0.svg";